import {
	type FlagComponent,
	GB,
	LT,
	LV,
	PL,
	RU,
	UA,
} from 'country-flag-icons/react/3x2';

// Language code → flag; 'en' shows the UK flag, 'ua' is this app's code for
// Ukrainian (not ISO 'uk').
const FLAGS: Record<string, FlagComponent> = {
	en: GB,
	lt: LT,
	lv: LV,
	pl: PL,
	ru: RU,
	ua: UA,
};

const LanguageFlag = ({ code }: { code: string }) => {
	const Flag = FLAGS[code?.toLowerCase()];
	if (!Flag) return null;
	return (
		<Flag
			style={{
				width: 20,
				minWidth: 20,
				borderRadius: 2,
				display: 'block',
			}}
		/>
	);
};

export default LanguageFlag;
